import "bootstrap/js/dist/tab";

export default function DepositsTabs() {
    let prevScrollTop = 0;
    let currentScrollTop = 0;
    let fxiTopHeader = document.querySelector(".fxi-top-header");
    let depositsTabsWrapper = document.getElementsByClassName(
      "deposits-tabs_sm-wrapper"
    )[0];
	var depositsSelectedId = document.getElementById("deposits-tabs_select-id");
	var depositsNavLinks = document.querySelectorAll(
	  ".deposits-tabs_nav .nav-link"
	);
	var depositsOptions = document.querySelectorAll(".deposits-tabs_option");
	var depositsTabs = document.querySelectorAll(".deposits-tabs_tab-pane");

	window.addEventListener("scroll", function () {
      const a = window.scrollY;
      const b = fxiTopHeader && fxiTopHeader.clientHeight;

      currentScrollTop = a;

      if (this.window.innerWidth < 992) {
        if (prevScrollTop < currentScrollTop && a > b + b) {
          depositsTabsWrapper &&
          depositsTabsWrapper.classList.remove("deposits-tabs_sm-scroll-down");
        } else if (prevScrollTop > currentScrollTop && !(a <= b)) {
          depositsTabsWrapper &&
          depositsTabsWrapper.classList.add("deposits-tabs_sm-scroll-down");
        }
        prevScrollTop = currentScrollTop;
      }
    });

    function selectOption(index) {
      if (depositsSelectedId) {
        depositsSelectedId.options.selectedIndex = index;
      }
    }
    
	depositsNavLinks &&
      depositsNavLinks.forEach((navLink) => {
        navLink.addEventListener("click", function () {
          if (navLink.classList.contains("active")) {
            depositsOptions &&
            depositsOptions.forEach((option) => {
              if (option.value === navLink.getAttribute("aria-controls")) {
                if (depositsSelectedId) {
                  depositsSelectedId.value = option.value;
                  selectOption(option.index);
                }
              }
            });
          }
        });
    });

    function showSelectedAciveItem() {
      depositsOptions &&
      depositsOptions.forEach((option) => {
        if (depositsSelectedId) {
          if (option.index === depositsSelectedId.options.selectedIndex) {
            depositsNavLinks &&
            depositsNavLinks.forEach((navLink) => {
              if (option.value === navLink.getAttribute("aria-controls")) {
                navLink.classList.add("active");
              } else {
                navLink.classList.remove("active");
              }
              });
              depositsTabs &&
              depositsTabs.forEach((tabContent) => {
              if (option.value === tabContent.id) {
                tabContent.classList.add("active", "show");
              } else {
                tabContent.classList.remove("active", "show");
              }
            });
          }
        }
      });
    }

	depositsSelectedId && depositsSelectedId.addEventListener("change", showSelectedAciveItem);
}
